import React from 'react';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import {
  CommonItemProps,
  MenuItemType,
} from '#/components/layout/header/headerTypes';
import { fullLogoutAndDispatch } from '#/reduxState/currentUser/currentUserUtils';
import { staticDispatch, useSelector } from '#/reduxState/store';

import MenuItemRenderer from '../MenuItemRenderer';

function LockWalletMenuItem({ $linkProps }: CommonItemProps) {
  const loggedIn = useSelector(state => state.currentUser.loggedIn);
  const wallet = useSelector(state => state.wallet);
  const delegatedWallet = useSelector(
    state => state.delegatedKey.authorization
  );
  const isCatchAllUser = useSelector(state => state.currentUser.isCatchAllUser);

  const title = loggedIn && !isCatchAllUser ? 'Sign Out' : 'Disconnect';

  return (
    <MenuItemRenderer
      linkProps={{
        ...$linkProps,
        title,
        icon: (
          <MaterialSymbol icon="close" fontSize="small" color="var(--gray4c)" />
        ),
        onClick: () => {
          // Since this is actually its own UX / UI we need to manually save the state
          // here immediately so that the indicator can be set properly when visited.
          fullLogoutAndDispatch(wallet, delegatedWallet, staticDispatch);
        },
      }}
      menuItem={{
        type: 'DropdownMenuLink' as const,
        label: title,
      }}
    />
  );
}

const LockWalletItem: MenuItemType = {
  type: 'MenuBox',
  Component: LockWalletMenuItem,
};

export default LockWalletItem;
